"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "localize", {
  enumerable: true,
  get: function get() {
    return _Localize.localize;
  }
});
Object.defineProperty(exports, "concatMiddleware", {
  enumerable: true,
  get: function get() {
    return _concatMiddleware.default;
  }
});
Object.defineProperty(exports, "connectToWebChat", {
  enumerable: true,
  get: function get() {
    return _connectToWebChat.default;
  }
});
Object.defineProperty(exports, "Context", {
  enumerable: true,
  get: function get() {
    return _Context.default;
  }
});
Object.defineProperty(exports, "createCoreActivityMiddleware", {
  enumerable: true,
  get: function get() {
    return _createCoreMiddleware.default;
  }
});
Object.defineProperty(exports, "createCoreAttachmentMiddleware", {
  enumerable: true,
  get: function get() {
    return _createCoreMiddleware2.default;
  }
});
Object.defineProperty(exports, "createStyleSet", {
  enumerable: true,
  get: function get() {
    return _createStyleSet.default;
  }
});
Object.defineProperty(exports, "defaultStyleOptions", {
  enumerable: true,
  get: function get() {
    return _defaultStyleOptions.default;
  }
});
Object.defineProperty(exports, "getTabIndex", {
  enumerable: true,
  get: function get() {
    return _getTabIndex.default;
  }
});
exports.version = exports.Components = exports.default = void 0;

var _BasicWebChat = _interopRequireDefault(require("./BasicWebChat"));

var _Composer = _interopRequireDefault(require("./Composer"));

var _Avatar = _interopRequireDefault(require("./Activity/Avatar"));

var _Bubble = _interopRequireDefault(require("./Activity/Bubble"));

var _CarouselLayout = _interopRequireDefault(require("./Activity/CarouselLayout"));

var _ErrorBox = _interopRequireDefault(require("./ErrorBox"));

var _Localize = _interopRequireWildcard(require("./Localization/Localize"));

var _SendStatus = _interopRequireWildcard(require("./Activity/SendStatus"));

var _Speak = _interopRequireWildcard(require("./Activity/Speak"));

var _StackedLayout = _interopRequireWildcard(require("./Activity/StackedLayout"));

var _Timestamp = _interopRequireDefault(require("./Activity/Timestamp"));

var _AudioContent = _interopRequireDefault(require("./Attachment/AudioContent"));

var _HTMLVideoContent = _interopRequireDefault(require("./Attachment/HTMLVideoContent"));

var _ImageContent = _interopRequireDefault(require("./Attachment/ImageContent"));

var _TextContent = _interopRequireDefault(require("./Attachment/TextContent"));

var _VideoContent = _interopRequireDefault(require("./Attachment/VideoContent"));

var _VimeoContent = _interopRequireDefault(require("./Attachment/VimeoContent"));

var _YouTubeContent = _interopRequireDefault(require("./Attachment/YouTubeContent"));

var _DictationInterims = _interopRequireWildcard(require("./SendBox/DictationInterims"));

var _MicrophoneButton = _interopRequireWildcard(require("./SendBox/MicrophoneButton"));

var _SendButton = _interopRequireWildcard(require("./SendBox/SendButton"));

var _TextBox = _interopRequireWildcard(require("./SendBox/TextBox"));

var _SuggestedActions = _interopRequireWildcard(require("./SendBox/SuggestedActions"));

var _UploadButton = _interopRequireWildcard(require("./SendBox/UploadButton"));

var _concatMiddleware = _interopRequireDefault(require("./Middleware/concatMiddleware"));

var _connectToWebChat = _interopRequireDefault(require("./connectToWebChat"));

var _Context = _interopRequireDefault(require("./Context"));

var _createCoreMiddleware = _interopRequireDefault(require("./Middleware/Activity/createCoreMiddleware"));

var _createCoreMiddleware2 = _interopRequireDefault(require("./Middleware/Attachment/createCoreMiddleware"));

var _createStyleSet = _interopRequireDefault(require("./Styles/createStyleSet"));

var _defaultStyleOptions = _interopRequireDefault(require("./Styles/defaultStyleOptions"));

var _getTabIndex = _interopRequireDefault(require("./Utils/TypeFocusSink/getTabIndex"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var version = "4.5.0";
exports.version = version;
var Components = {
  Composer: _Composer.default,
  Localize: _Localize.default,
  // Components for recomposing activities and attachments
  AudioContent: _AudioContent.default,
  HTMLVideoContent: _HTMLVideoContent.default,
  ImageContent: _ImageContent.default,
  TextContent: _TextContent.default,
  VideoContent: _VideoContent.default,
  VimeoContent: _VimeoContent.default,
  YouTubeContent: _YouTubeContent.default,
  // Components for recomposing transcript
  Avatar: _Avatar.default,
  Bubble: _Bubble.default,
  CarouselLayout: _CarouselLayout.default,
  ErrorBox: _ErrorBox.default,
  SendStatus: _SendStatus.default,
  SpeakActivity: _Speak.default,
  StackedLayout: _StackedLayout.default,
  Timestamp: _Timestamp.default,
  connectSendStatus: _SendStatus.connectSendStatus,
  connectSpeakActivity: _Speak.connectSpeakActivity,
  connectStackedLayout: _StackedLayout.connectStackedLayout,
  // Components for recomposing send box
  DictationInterims: _DictationInterims.default,
  MicrophoneButton: _MicrophoneButton.default,
  SendButton: _SendButton.default,
  SendTextBox: _TextBox.default,
  SuggestedActions: _SuggestedActions.default,
  UploadButton: _UploadButton.default,
  connectDictationInterims: _DictationInterims.connectDictationInterims,
  connectMicrophoneButton: _MicrophoneButton.connectMicrophoneButton,
  connectSendButton: _SendButton.connectSendButton,
  connectSendTextBox: _TextBox.connectSendTextBox,
  connectSuggestedActions: _SuggestedActions.connectSuggestedActions,
  connectUploadButton: _UploadButton.connectUploadButton
};
exports.Components = Components;
var _default = _BasicWebChat.default;
exports.default = _default;